(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
        // document.querySelector('.scroll-logo').classList.remove('show-logo')
        // document.querySelector('.header__heading-logo').classList.remove('hide-logo')
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-redesign"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  // The only variants that activate the toggle. Anything else — 'none', an empty value, or a
  // missing attribute — leaves the gallery unfiltered, which is the safe live baseline.
  const GENDER_TOGGLE_VARIANTS = ['variant-1', 'variant-2', 'variant-3'];

  class GenderToggle extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-gender-option]'));

      // global.js's filterThumbnails() calls getActiveGender() on any
      // gender-toggle element regardless of this setting, so this.buttons
      // must stay populated even when the toggle itself is disabled.

      this.onOptionClick = this.onOptionClick.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.observeVariant();

      if (this.isVariantActive()) this.activate();
    }

    disconnectedCallback() {
      if (this.variantObserver) this.variantObserver.disconnect();
      this.buttons.forEach((button) => button.removeEventListener('click', this.onOptionClick));
    }

    // Read <html> first: Intelligems runs onsite JS edits from <head>, where document.body is
    // still null, so <html> is the only element an IG edit can write to. <body> is the fallback
    // for the plain theme-setting path.
    getVariant() {
      return (
        document.documentElement.dataset.genderToggleVariant ||
        document.body?.dataset.genderToggleVariant ||
        'none'
      );
    }

    isVariantActive() {
      return GENDER_TOGGLE_VARIANTS.includes(this.getVariant());
    }

    // An IG edit may land after this element has already connected. Watch both elements so a
    // late write still activates the toggle instead of being silently ignored. Activation is
    // one-way — a bucket does not change mid-session, so there is no deactivate path.
    observeVariant() {
      this.variantObserver = new MutationObserver(this.onVariantChange);
      [document.documentElement, document.body].forEach((el) => {
        if (el) {
          this.variantObserver.observe(el, {
            attributes: true,
            attributeFilter: ['data-gender-toggle-variant'],
          });
        }
      });
    }

    onVariantChange() {
      if (this.activated || !this.isVariantActive()) return;
      this.activate();
    }

    activate() {
      this.activated = true;
      this.scope = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.storageKey = `product-gender-${this.dataset.section}`;

      const savedGender = window.localStorage?.getItem(this.storageKey);
      const activeGender = this.buttons.some((button) => button.dataset.genderOption === savedGender)
        ? savedGender
        : this.getActiveGender();

      this.syncAvatarImages();
      this.setActiveGender(activeGender, false);
      this.applyGender(activeGender);

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.onOptionClick);
      });
    }

    getActiveGender() {
      const activeButton = this.buttons.find((button) => button.getAttribute('aria-current') === 'true');
      return activeButton ? activeButton.dataset.genderOption : 'man';
    }

    syncAvatarImages() {
      if (!this.scope) return;

      this.buttons.forEach((button) => {
        const gender = button.dataset.genderOption;
        const avatar = button.querySelector('.gender-toggle__avatar');
        if (!avatar) return;

        const candidate = Array.from(this.scope.querySelectorAll('[data-gender]')).find((el) => {
          const mediaGender = el.dataset.gender;
          return mediaGender === gender || mediaGender === 'both';
        });

        const image = candidate?.querySelector('img');
        const source = image ? image.currentSrc || image.src : '';
        avatar.style.backgroundImage = source ? `url("${source}")` : '';
      });
    }

    setActiveGender(gender, persist = true) {
      this.buttons.forEach((button) => {
        button.setAttribute('aria-current', button.dataset.genderOption === gender ? 'true' : 'false');
      });

      this.updateOptionValueLabel(gender);

      if (persist && window.localStorage) {
        window.localStorage.setItem(this.storageKey, gender);
      }
    }

    updateOptionValueLabel(gender) {
      const activeButton = this.buttons.find((button) => button.dataset.genderOption === gender);
      const label = activeButton?.querySelector('.gender-toggle__label')?.textContent || '';
      const optionValue = this.querySelector('.option__value');
      if (optionValue) optionValue.textContent = label;
    }

    applyGender(gender) {
      if (!this.scope) return;

      // ModalDialog.connectedCallback (assets/global.js) relocates <product-modal> to <body>, so
      // the lightbox sits OUTSIDE MainProduct-* and has to be filtered as a second root — without
      // this it keeps showing off-gender media. Looked up per call rather than cached: the modal
      // is parsed after this component connects, so it may not exist yet at activate() time.
      const modal = document.getElementById(`ProductModal-${this.dataset.section}`);
      const roots = modal ? [this.scope, modal] : [this.scope];

      roots.forEach((root) => {
        root.querySelectorAll('[data-gender]').forEach((el) => {
          const mediaGender = el.dataset.gender;
          const shouldShow = mediaGender === gender || mediaGender === 'both';
          el.style.display = shouldShow ? '' : 'none';
        });
      });

      this.syncAvatarImages();

      this.scope
        .querySelectorAll('[id^="GalleryViewer-"], [id^="GalleryThumbnails-"], [id^="GalleryVerticalThumbnails-"]')
        .forEach((slider) => {
          if (typeof slider.resetPages === 'function') slider.resetPages();
        });
    }

    onOptionClick(event) {
      const gender = event.currentTarget.dataset.genderOption;
      if (event.currentTarget.getAttribute('aria-current') === 'true' || !this.scope) return;

      this.setActiveGender(gender);
      this.applyGender(gender);
    }
  }

  if (!customElements.get('gender-toggle')) {
    customElements.define('gender-toggle', GenderToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-template-2021"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
